// src/layouts/PrivateLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/common/Navbar/Navbar'
// import PostLoginNavbar from '../components/common/PostLoginNavbar/Navbar';

const PrivateLayout = () => {
  return (
    <div>
      <Navbar /> {/* Navbar will be displayed on protected routes */}
      <Outlet /> {/* Renders the child routes like HomePage, Profile, etc */}
    </div>
  );
};

export default PrivateLayout;
